import { CardSvg } from '@/play/cardSvg'

/** Home card art: a stone slab with an A carved in it, half filled with pink goo. */
export function GrooveLettersCardArt() {
  return (
    <CardSvg bg="#f1efe9">
      {/* the slab, its top seen from above and its front edge */}
      <path d="M58 30 H 262 L 278 162 H 42 Z" fill="#ece4d6" />
      <path d="M42 162 H 278 V 180 H 42 Z" fill="#a98a70" />
      {/* the groove: an A, carved (dark) */}
      <g fill="none" stroke="#a98a70" strokeWidth="16" strokeLinecap="round" strokeLinejoin="round">
        <path d="M160 48 L 118 146" />
        <path d="M160 48 L 202 146" />
        <path d="M136 108 H 184" />
      </g>
      {/* goo in the first stroke and part of the second */}
      <g fill="none" stroke="#ff5fa2" strokeWidth="11" strokeLinecap="round" strokeLinejoin="round">
        <path d="M160 50 L 119 144" />
        <path d="M160 50 L 176 88" />
      </g>
      <path d="M150 66 L 140 88" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" opacity="0.55" />
    </CardSvg>
  )
}
